import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    background: #111;
    color: #fff;
    font-family: 'Barlow', sans-serif;
    font-size: 18px;
  }

  input, button {
    font-family: 'Barlow', sans-serif;
  }

  .container {
    width: 1100px;
  }

  @media (max-width: 1200px) {
    .container {
      width: 90% !important;
    }
  }

  @media (max-width: 860px) {
    .container {
      width: 95% !important;
    }
    .hero__grid2, .info__grid3, .faq__grid2 {
      grid-template-columns: repeat(1, 1fr) !important;
    }
    .footer__wrapper {
      flex-direction: column !important;
    }
  }

  @media (max-width: 860px) {
    .hero__grid2, .info__grid3, .faq__grid2 {
      grid-template-columns: repeat(1, 1fr) !important;
    }
    .footer__wrapper {
      display: grid !important;
      grid-gap: 50px !important;
    }
  }

  @media (max-width: 600px) {
    .navbar__wrapper {
      display: grid !important;
      grid-template-columns: repeat(1,1fr) !important;
      grid-gap: 50px !important;
      justify-items: center !important;
    }
    .hero__wrapper, .download__buttons {
      display: grid !important;
      grid-gap: 50px !important;
    }
    .download__buttons {
      width: 100% !important;
    }
    .btn-chrome, .btn-firefox, .btn-edge {
      width: 100% !important;
      justify-content: center !important;
    }
    .btn-firefox {
      margin: 0 !important;
    }
    .browsers__grid3 {
      grid-template-columns: repeat(1,1fr) !important;
    }
  }

  @media (max-width: 330px) {
    .social__wrapper {
      flex-direction: column !important;
    }
  }
`

export default GlobalStyle
